module.exports = {"data":{"page":{"id":"/opt/build/repo/content/pages/2--starters/index.md absPath of file >>> MarkdownRemark","html":"","frontmatter":{"title":"I am Batman"}},"footnote":{"id":"/opt/build/repo/content/parts/footnote.md absPath of file >>> MarkdownRemark","html":""}},"pathContext":{"slug":"/starters/"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/starters.json
// module id = 592
// module chunks = 230064834116715